<div class="cw-container-login">
    <div class="cw-login">
        <router-outlet></router-outlet>
    </div>
    <div class="cw-login-footer">© Pharmakon Software GmbH</div>
</div>